<div class="spinner-background" [style.opacity]="highOpacity() ? 0.4 : 0.2"></div>

<p-progressSpinner [ariaLabel]="ariaLabel()" class="bi-spinner" [styleClass]="spinnerSize()" />

<b *ngIf="message()" class="bi-spinner">{{ message() }}</b>
